import * as React from 'react';
import { DotsThreeVerticalIcon } from '@phosphor-icons/react';
import { cn } from '@/utils/cn';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

// Reusable per-row "…" actions menu (the shared pattern for table row actions —
// don't hand-roll a DropdownMenu per table). Each action is an icon + label;
// the menu is sized so icon + text sit comfortably full-width.
export type RowAction = {
  label: string;
  icon?: React.ReactNode;
  onSelect: () => void;
  disabled?: boolean;
  destructive?: boolean;
  title?: string;
  separatorBefore?: boolean;
};

export function RowActionsMenu({
  actions,
  label = 'Actions',
  align = 'end',
}: {
  actions: RowAction[];
  label?: string;
  align?: 'start' | 'center' | 'end';
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={label}>
          <DotsThreeVerticalIcon size={16} weight="bold" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="min-w-52">
        {actions.map((action, index) => (
          <React.Fragment key={index}>
            {action.separatorBefore && index > 0 && <DropdownMenuSeparator />}
            <DropdownMenuItem
              onSelect={action.onSelect}
              disabled={action.disabled}
              title={action.title}
              className={cn(
                action.destructive && 'text-destructive focus:text-destructive',
              )}
            >
              {action.icon}
              {action.label}
            </DropdownMenuItem>
          </React.Fragment>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
